import apiHelperForBank from "@/http/apiHelperForBank";
export default {
  // login
  login(body) {
    return apiHelperForBank.post(`/login`, body);
  },

  // updateUser
  updateUser(body, userId) {
    return apiHelperForBank.put(`/users/${userId}`, body);
  },

  // updateUserByClientId
  updateUserByClientId(body, clientId, tenatId) {
    return apiHelperForBank.put(
      `/users/by-client/${clientId}/${tenatId}`,
      body,
    );
  },

  // retrieveAUser
  retrieveAUser(userId) {
    return apiHelperForBank.get(`/users/${userId}`);
  },
  // retrieveAUser
  retrieveAllAUser() {
    return apiHelperForBank.get(`/users`);
  },

  // forgotPassword
  forgotPassword(body = {}) {
    return apiHelperForBank.post(`/forgot-password`, body);
  },

  // forgotPassword
  comleteStokvel(body = {}) {
    return apiHelperForBank.post(`/stokvels/compleate-stokvel`, body);
  },

  // Token
  stokvelByToken(token) {
    return apiHelperForBank.get(`/stokvels/token/${token}`);
  },

  // resetPassword
  resetPassword(body = {}) {
    return apiHelperForBank.post(`/reset-password`, body);
  },

  verifyUserClient(body = {}) {
    return apiHelperForBank.post(`/verify-user-client`, body);
  },

  // changePassword
  changePassword(body) {
    return apiHelperForBank.post(`/change-password`, body);
  },

  // categorizedPayment
  categorizedPayment(body) {
    return apiHelperForBank.post(`/catergorisedpayment`, body);
  },

  // getTenants
  getTenants(companyName) {
    return apiHelperForBank.get(`/public/tenants/${companyName}`);
  },

  // loginIntoTenant
  loginIntoTenant(body = {}) {
    return apiHelperForBank.post(`/tenants/auth/login`, body);
  },

  // createBankInvestment
  createBankInvestment(body = {}) {
    return apiHelperForBank.post(`/public/investments`, body);
  },

  //investment
  // getInvestment
  getInvestments() {
    return apiHelperForBank.get(`/investment`);
  },

  getInvestmentsByCompanyName(companyName) {
    return apiHelperForBank.get(`/investment/company/${companyName}`);
  },

  createLoanEligibilityMultiplier(body) {
    return apiHelperForBank.post(`/loan-eligibility-multipliers`, body);
  },

  updateLoanEligibilityMultiplier(body) {
    return apiHelperForBank.put(`/loan-eligibility-multipliers`, body);
  },

  getLoanEligibilityMultipliersByTenant(tenantIdentifier) {
    return apiHelperForBank.get(
      `public/loan-eligibility-multipliers/by-tenant/${tenantIdentifier}`,
    );
  },

  createLoanRequestsVisibility(body) {
    return apiHelperForBank.post(`/loan-requests-visibilities`, body);
  },

  updateLoanRequestsVisibility(body) {
    return apiHelperForBank.put(`/loan-requests-visibilities`, body);
  },

  getLoanRequestsVisibilityByTenant(tenantIdentifier) {
    return apiHelperForBank.get(
      `public/loan-requests-visibilities/by-tenant/${tenantIdentifier}`,
    );
  },

  // bulk uploads
  // createBulkUpload
  createBulkUpload(body = {}) {
    return apiHelperForBank.post(`/bulkUploads`, body);
  },

  // getBulkUploads
  getBulkUploadById(id) {
    return apiHelperForBank.get(`/bulkUploads/${id}`);
  },

  // getBulkUploads
  getBulkUploads() {
    return apiHelperForBank.get(`/bulkUploads`);
  },

  // stokvelConstitution
  stokvelConstitution(tenantIdentifier) {
    return apiHelperForBank.get(
      `/public/stokvels/stokvel-details/${tenantIdentifier}`,
    );
  },

  // stokvelApplicationDocuments
  stokvelApplicationDocuments() {
    return apiHelperForBank.get(`/documents`);
  },

  // stokvelApplicationDocuments
  stokvelApplicationDocumentsById(id) {
    return apiHelperForBank.get(`/documents/stokvel/${id}`);
  },

  // updateInvestment
  updateInvestment(body, investmentId) {
    return apiHelperForBank.put(`/investment/${investmentId}`, body);
  },

  // createStokvelWithDocument
  createStokvelWithDocument(body = {}) {
    return apiHelperForBank.post(`/public/stokvelwithdocument`, body);
  },

  // upload stokvel documents (id, constitution)
  updateStokvelDocument(body, documentId) {
    return apiHelperForBank.put(`/documents/${documentId}`, body);
  },

  // createEmail
  createEmail(body = {}) {
    return apiHelperForBank.post(`/emails/send-email-with-html`, body);
  },

  sendLoanAgreement(body = {}) {
    return apiHelperForBank.post(`/loan-agreement`, body);
  },

  // getFullStatement
  getFullStatement(clientId, savingsAccountId, stokvel) {
    return apiHelperForBank.get(
      `/loan-agreement/interest-shares/${clientId}/${savingsAccountId}/${stokvel}`
    );
  },

  // createSMS
  createSMS(body = {}) {
    return apiHelperForBank.post(`/service/sms/send-sms`, body);
  },

  // registrationSMS
  createRegistrationSMS(body = {}) {
    return apiHelperForBank.post(`/service/sms/send-registrationsms`, body);
  },

  getStokvels() {
    return apiHelperForBank.get(`/stokvels`);
  },

  getStokvelsByCompanyName(companyName) {
    return apiHelperForBank.get(`/stokvels/company/${companyName}`);
  },

  deleteStokvels(id) {
    return apiHelperForBank.delete(`/stokvels/${id}`);
  },

  deleteTransactionts(id) {
    return apiHelperForBank.delete(`/transactions/${id}`);
  },

  // updateStokvel
  updateStokvels(body, StokvelId) {
    return apiHelperForBank.put(`/stokvels/${StokvelId}`, body);
  },

  // getInvestment
  getTransactions() {
    return apiHelperForBank.get(`/transactions`);
  },

  getTransactionsByCompanyName(companyName) {
    return apiHelperForBank.get(`/transactions/company/${companyName}`);
  },

  // updateTransaction
  updateTransactions(body, id) {
    return apiHelperForBank.put(`/transactions/${id}`, body);
  },

  //messaging

  getMessages() {
    return apiHelperForBank.get(`/message`);
  },
  getMessageById(id) {
    return apiHelperForBank.get(`/message/${id}`);
  },

  getMessageBySenderId(id) {
    return apiHelperForBank.get(`/message/sender/${id}`);
  },
  getMessageByReceiverId(id) {
    return apiHelperForBank.get(`/message/receiver/${id}`);
  },

  createMessages(body = {}) {
    return apiHelperForBank.post(`/messages`, body);
  },
  createMessagesDocument(body = {}) {
    return apiHelperForBank.post(`/message/document`, body);
  },

  updateMessage(body, messageId) {
    return apiHelperForBank.put(`/message/${messageId}`, body);
  },

  deleteMessage(id) {
    return apiHelperForBank.delete(`/message/${id}`);
  },

  //inbox

  getInbox() {
    return apiHelperForBank.get(`/inbox`);
  },

  getInboxById(id) {
    return apiHelperForBank.get(`/inbox/${id}`);
  },
  getInboxBySenderId(id) {
    return apiHelperForBank.get(`/inbox/sender/${id}`);
  },
  getInboxByReceiverId(id) {
    return apiHelperForBank.get(`/inbox/receiver/${id}`);
  },

  createInbox(body = {}) {
    return apiHelperForBank.post(`/inbox`, body);
  },

  updateInbox(body, inboxId) {
    return apiHelperForBank.put(`/sent/${inboxId}`, body);
  },

  deleteInbox(id) {
    return apiHelperForBank.delete(`/inbox/${id}`);
  },

  //sent

  getSent() {
    return apiHelperForBank.get(`/sent`);
  },

  getSentById(id) {
    return apiHelperForBank.get(`/sent/${id}`);
  },
  getSentBySenderId(id) {
    return apiHelperForBank.get(`/sent/sender/${id}`);
  },
  getSentByReceiverId(id) {
    return apiHelperForBank.get(`/sent/receiver/${id}`);
  },

  createSent(body = {}) {
    return apiHelperForBank.post(`/sent`, body);
  },

  updateSent(body, sentId) {
    return apiHelperForBank.put(`/sent/${sentId}`, body);
  },

  deleteSent(id) {
    return apiHelperForBank.delete(`/sent/${id}`);
  },

  //Document
  getDocument() {
    return apiHelperForBank.get(`/emailDocuments`);
  },

  getDocumentById(id) {
    return apiHelperForBank.get(`/emailDocuments/${id}`);
  },
  getDocumentBySenderId(id) {
    return apiHelperForBank.get(`/emailDocuments/sender/${id}`);
  },
  getDocumentByReceiverId(id) {
    return apiHelperForBank.get(`/emailDocuments/receiver/${id}`);
  },

  createDocument(body = {}) {
    return apiHelperForBank.post(`/emailDocuments`, body);
  },

  updateDocument(body, sentId) {
    return apiHelperForBank.put(`/emailDocuments/${sentId}`, body);
  },

  deleteDocument(id) {
    return apiHelperForBank.delete(`/emailDocuments/${id}`);
  },

  //Reply
  getReply() {
    return apiHelperForBank.get(`/reply`);
  },

  getReplyById(id) {
    return apiHelperForBank.get(`/reply/${id}`);
  },

  createReply(body = {}) {
    return apiHelperForBank.post(`/reply`, body);
  },

  updateReply(body, sentId) {
    return apiHelperForBank.put(`/reply/${sentId}`, body);
  },

  deleteReply(id) {
    return apiHelperForBank.delete(`/reply/${id}`);
  },

  //CC
  getCC() {
    return apiHelperForBank.get(`/cc`);
  },

  getCCById(id) {
    return apiHelperForBank.get(`/cc/${id}`);
  },
  getCCBySenderId(id) {
    return apiHelperForBank.get(`/cc/sender/${id}`);
  },
  getCCByReceiverId(id) {
    return apiHelperForBank.get(`/cc/receiver/${id}`);
  },

  createCC(body = {}) {
    return apiHelperForBank.post(`/cc`, body);
  },

  updateCC(body, sentId) {
    return apiHelperForBank.put(`/cc/${sentId}`, body);
  },

  deleteCC(id) {
    return apiHelperForBank.delete(`/cc/${id}`);
  },

  //finclude

  getImageById(id) {
    return apiHelperForBank.get(`/retrieve_image/${id}`);
  },

  createObjectList(body = {}) {
    return apiHelperForBank.post(`/objectList`, body);
  },

  createAirtimeData(body = {}) {
    return apiHelperForBank.post(`/airtimeData`, body);
  },

  createMobilePay(body = {}) {
    return apiHelperForBank.post(`/mobilePay`, body);
  },

  createPrepaidUtility(body = {}) {
    return apiHelperForBank.post(`/prepaidUtility`, body);
  },

  createBillPayment(body = {}) {
    return apiHelperForBank.post(`/billPayment`, body);
  },

  createPrepaidUtilitySale(body = {}) {
    return apiHelperForBank.post(`/prepaidUtilitySale`, body);
  },

  // Product Payback Methods
  createProductPaybackMethod(body) {
    return apiHelperForBank.post(`/product-payback-methods`, body);
  },

  getProductPaybackMethodsByProduct(productId) {
    return apiHelperForBank.get(
      `/product-payback-methods/by-product/${productId}`,
    );
  },

  createFincludeTransactionst(body = {}) {
    return apiHelperForBank.post(`/fincludeTransactions`, body);
  },

  getFincludeTransactions() {
    return apiHelperForBank.get(`/fincludeTransactions`);
  },
};
